/**
 * Google MerchantWidget badge loader.
 *
 * Decides whether the Google store-quality badge should be shown for the
 * current store region, then lazily loads and starts the MerchantWidget.
 *
 * Liquid-dependent data (store region + store-quality metaobject values) is
 * provided via `window._erj_.googleBadge`, populated inline in the page head.
 * Keeping the logic here lets the script be deferred so it never blocks FCP.
 */
(function () {
  const config = window._erj_ && window._erj_.googleBadge;
  if (!config) return;

  const storeRegion = config.storeRegion;
  const googleStoreQuality = Array.isArray(config.storeQuality) ? config.storeQuality : [];
  const forceShowGoogleBadge =
    new URLSearchParams(window.location.search).get('forceshowgooglebadge') === 'true';

  const regionEntry = googleStoreQuality.find((entry) => entry.country_code === storeRegion);

  if (!regionEntry) {
    console.log('Display MerchantWidget: false (region not in store metaobject)');
    return;
  }

  // Extract all rating values
  const overallScore = parseFloat(regionEntry.overall_score);
  const shippingRating = parseInt(regionEntry.shipping_rating) || 0;
  const returnsRating = parseInt(regionEntry.returns_rating) || 0;
  const pricingRating = parseInt(regionEntry.pricing_rating) || 0;
  const paymentRating = parseInt(regionEntry.payment_rating) || 0;
  const websiteRating = parseInt(regionEntry.website_rating) || 0;
  const minimumAcceptableRating = parseInt(regionEntry.minimum_acceptable_rating) || 4;
  const showBadgeCheckbox = regionEntry.show_badge !== false;

  // Check if all individual ratings meet the minimum acceptable rating
  const allRatingsMeetMinimum = [
    shippingRating,
    returnsRating,
    pricingRating,
    paymentRating,
    websiteRating,
  ].every((rating) => rating >= minimumAcceptableRating);

  const isTopQualityStore = regionEntry.badgetopquality === true;
  const hasScore = overallScore > 0;
  const hasRatings = shippingRating > 0;

  // Data-driven badge display logic:
  // A-class (has score + ratings): full checks required
  const modeAPass = hasScore && overallScore >= 4.0 && isTopQualityStore && allRatingsMeetMinimum;
  // B-class (ratings only, no score): sub-ratings must meet minimum
  const modeBPass = !hasScore && hasRatings && allRatingsMeetMinimum;

  // show_badge (showBadgeCheckbox) is always a manual switch
  const showBadge = forceShowGoogleBadge || ((modeAPass || modeBPass) && showBadgeCheckbox);

  if (forceShowGoogleBadge) {
    console.log('Badge forced to show via URL parameter');
  }

  if (showBadge) {
    console.log('Display MerchantWidget: true');

    const script_a = document.createElement('script');
    script_a.id = 'merchantWidgetScript';
    script_a.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script_a.defer = true;
    document.head.appendChild(script_a);

    script_a.addEventListener('load', function () {
      merchantwidget.start({
        region: storeRegion,
        position: 'RIGHT_BOTTOM',
        sideMargin: 10,
        bottomMargin: 120,
        mobileSideMargin: 0,
        mobileBottomMargin: 120,
      });
    });
  } else {
    let reason = '';
    if (!hasRatings) reason = 'no rating data (D-class)';
    else if (hasScore && !isTopQualityStore) reason = 'not a top quality store';
    else if (hasScore && overallScore < 4.0) reason = 'overall score too low (' + overallScore + ')';
    else if (!allRatingsMeetMinimum) reason = 'individual ratings below minimum';
    else if (!showBadgeCheckbox) reason = 'badge manually disabled';
    console.log('Display MerchantWidget: false (' + reason + ')');
  }
})();
